var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('p',[_vm._v(_vm._s(_vm.$route.meta.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }